import React from 'react';
import classnames from 'classnames';
import { BubbleProps } from 'tea-component';
import { Bubble } from '@home/components/TeaComponents';
import SvgIcon from '@home/components/SvgIcon';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface ITimeChangeLegendProps extends IBaseProps {
  // 图例名称
  name?: string | React.ReactElement;
  // 气泡提示内容
  tips?: string;
  // Bubble组件的props
  bubbleProps?: Omit<BubbleProps, 'content'>;
}

const TimeChangeLegend: React.FC<ITimeChangeLegendProps> = (props) => {
  const { style, className, name = 'Time Change', tips, bubbleProps } = props;
  const {
    className: bubbleClassName,
    dark: bubbleDark = true,
    arrowPointAtCenter: bubbleArrowPointAtCenter = true,
    ...restBubbleProps
  } = bubbleProps || {};

  return (
    <div style={style} className={classnames('dbg-time-change-legend', className)}>
      <Bubble
        {...restBubbleProps}
        className={classnames('dbg-bubble-max-width dbg-time-change-legend__bubble', bubbleClassName)}
        dark={bubbleDark}
        arrowPointAtCenter={bubbleArrowPointAtCenter}
        content={tips}
      >
        <div>
          <SvgIcon className="dbg-time-change-legend__icon" type="updating" />
        </div>
      </Bubble>
      {!!name && <span className="dbg-time-change-legend__name">{name}</span>}
    </div>
  );
};

export default TimeChangeLegend;
